import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginAttemptMonitor = ({ attempts, maxAttempts, lockoutTime }) => {
  const remainingAttempts = maxAttempts - attempts;
  const isWarning = remainingAttempts <= 2;
  const isLocked = remainingAttempts <= 0;

  if (attempts === 0) return null;

  return (
    <div className={`flex items-start gap-3 p-4 rounded-lg border ${
      isLocked 
        ? 'bg-error/10 border-error/20' 
        : isWarning 
        ? 'bg-warning/10 border-warning/20' :'bg-muted/50 border-border'
    }`}>
      <Icon 
        name={isLocked ? 'Lock' : 'AlertTriangle'} 
        size={20} 
        className={`flex-shrink-0 mt-0.5 ${
          isLocked ? 'text-error' : isWarning ? 'text-warning' : 'text-muted-foreground'
        }`} 
      />
      <div className="flex-1">
        <p className={`text-sm font-semibold mb-1 ${
          isLocked ? 'text-error' : isWarning ? 'text-warning' : 'text-foreground'
        }`}>
          {isLocked 
            ? 'Konto gesperrt' 
            : `${remainingAttempts} Versuch${remainingAttempts !== 1 ? 'e' : ''} verbleibend`
          }
        </p>
        <p className="text-xs text-muted-foreground">
          {isLocked 
            ? `Ihr Konto wurde für ${lockoutTime} Minuten gesperrt. Bitte kontaktieren Sie den IT-Helpdesk.`
            : 'Nach weiteren fehlgeschlagenen Anmeldeversuchen wird Ihr Konto vorübergehend gesperrt.'
          }
        </p>
      </div>
    </div>
  );
};

export default LoginAttemptMonitor;